module.exports = __webpack_public_path__ + "img/icon_manejo_de_tarjetas.685f6285.svg";